import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['TransducerModel'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getTransducerModelById: build.query<GetTransducerModelByIdApiResponse, GetTransducerModelByIdApiArg>({
        query: (queryArg) => ({ url: `/TransducerModel/${queryArg}` }),
        providesTags: ['TransducerModel'],
      }),
      deleteTransducerModelById: build.mutation<DeleteTransducerModelByIdApiResponse, DeleteTransducerModelByIdApiArg>({
        query: (queryArg) => ({ url: `/TransducerModel/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['TransducerModel'],
      }),
      getTransducerModelGetAll: build.query<GetTransducerModelGetAllApiResponse, GetTransducerModelGetAllApiArg>({
        query: () => ({ url: `/TransducerModel/get-all` }),
        providesTags: ['TransducerModel'],
      }),
      getTransducerModelByIdHasData: build.query<
        GetTransducerModelByIdHasDataApiResponse,
        GetTransducerModelByIdHasDataApiArg
      >({
        query: (queryArg) => ({ url: `/TransducerModel/${queryArg}/has-data` }),
        providesTags: ['TransducerModel'],
      }),
      getTransducerModelByIdIsReferenced: build.query<
        GetTransducerModelByIdIsReferencedApiResponse,
        GetTransducerModelByIdIsReferencedApiArg
      >({
        query: (queryArg) => ({ url: `/TransducerModel/${queryArg}/is-referenced` }),
        providesTags: ['TransducerModel'],
      }),
      postTransducerModel: build.mutation<PostTransducerModelApiResponse, PostTransducerModelApiArg>({
        query: (queryArg) => ({ url: `/TransducerModel`, method: 'POST', body: queryArg }),
        invalidatesTags: ['TransducerModel'],
      }),
      putTransducerModel: build.mutation<PutTransducerModelApiResponse, PutTransducerModelApiArg>({
        query: (queryArg) => ({ url: `/TransducerModel`, method: 'PUT', body: queryArg }),
        invalidatesTags: ['TransducerModel'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as transducerModelApi };
export type GetTransducerModelByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTransducerModelExternalDto;
export type GetTransducerModelByIdApiArg = number;
export type DeleteTransducerModelByIdApiResponse = unknown;
export type DeleteTransducerModelByIdApiArg = number;
export type GetTransducerModelGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTransducerModelExternalDto;
export type GetTransducerModelGetAllApiArg = void;
export type GetTransducerModelByIdHasDataApiResponse = /** status 200 OK */ boolean;
export type GetTransducerModelByIdHasDataApiArg = /** Transducer model ID */ number;
export type GetTransducerModelByIdIsReferencedApiResponse = /** status 200 OK */ boolean;
export type GetTransducerModelByIdIsReferencedApiArg = /** Transducer model ID */ number;
export type PostTransducerModelApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTransducerModelExternalDto;
export type PostTransducerModelApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoTransducerModelExternalDto;
export type PutTransducerModelApiResponse = unknown;
export type PutTransducerModelApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoTransducerModelExternalDto;
export type ApiDatabaseCommonTransducerType = 0 | 1 | 2;
export type ApiCommonExternalDtoTransducerModelExternalDto = {
  id?: number;
  tsoId?: number;
  manufacturer: string;
  model: string;
  type: ApiDatabaseCommonTransducerType;
  voltageFrequencyDeviationMagnitude1?: number | null;
  voltageFrequencyDeviationMagnitude10?: number | null;
  voltageFrequencyDeviationPhaseAngle1?: number | null;
  voltageFrequencyDeviationPhaseAngle10?: number | null;
  currentFrequencyDeviationMagnitude1?: number | null;
  currentFrequencyDeviationMagnitude10?: number | null;
  currentFrequencyDeviationPhaseAngle1?: number | null;
  currentFrequencyDeviationPhaseAngle10?: number | null;
  voltageRatioPrimary?: number | null;
  voltageRatioSecondary?: number | null;
  currentRatioPrimary?: number | null;
  currentRatioSecondary?: number | null;
  comment: string;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTransducerModelExternalDto = {
  externalDto?: ApiCommonExternalDtoTransducerModelExternalDto;
  externalDtos?: ApiCommonExternalDtoTransducerModelExternalDto[] | null;
};
export type ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoTransducerModelExternalDto = {
  externalDto?: ApiCommonExternalDtoTransducerModelExternalDto;
};
export const {
  useGetTransducerModelByIdQuery,
  useLazyGetTransducerModelByIdQuery,
  useDeleteTransducerModelByIdMutation,
  useGetTransducerModelGetAllQuery,
  useLazyGetTransducerModelGetAllQuery,
  useGetTransducerModelByIdHasDataQuery,
  useLazyGetTransducerModelByIdHasDataQuery,
  useGetTransducerModelByIdIsReferencedQuery,
  useLazyGetTransducerModelByIdIsReferencedQuery,
  usePostTransducerModelMutation,
  usePutTransducerModelMutation,
} = injectedRtkApi;
